import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import axios from "axios";
import API_ENDPOINTS from "config/api";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function ProductosStockBajo() {
  const [productos, setProductos] = useState([]);
  const empresaId = localStorage.getItem("empresaId");

  useEffect(() => {
    fetchProductosStockBajo();
  }, [empresaId]);

  const fetchProductosStockBajo = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.INVENTARIO.STOCK_BAJO, {
        params: { empresa_id: empresaId },
      });
      setProductos(response.data.slice(0, 5)); // Top 5
    } catch (error) {
      console.error("Error al obtener productos con stock bajo:", error);
    }
  };

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={3} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Productos con Stock Bajo
        </MDTypography>
        <Icon fontSize="default" color="warning">
          warning
        </Icon>
      </MDBox>
      <MDBox pt={3} pb={2} px={2}>
        {productos.length > 0 ? (
          productos.map((producto, index) => (
            <MDBox key={producto.id}>
              <MDBox display="flex" justifyContent="space-between" mb={1}>
                <MDBox>
                  <MDTypography variant="button" fontWeight="medium" color="text">
                    {producto.nombre}
                  </MDTypography>
                  <MDTypography variant="caption" color="text" display="block">
                    Stock: {producto.stock_actual} / Min: {producto.stock_minimo}
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDTypography variant="button" color="error" fontWeight="medium">
                    {Math.round(
                      ((producto.stock_minimo - producto.stock_actual) / producto.stock_minimo) *
                        /* */ 100
                    )}
                    %
                  </MDTypography>
                </MDBox>
              </MDBox>
              {index < productos.length - 1 && <Divider />}
            </MDBox>
          ))
        ) : (
          <MDTypography variant="caption" color="text">
            No hay productos con stock bajo
          </MDTypography>
        )}
      </MDBox>
    </Card>
  );
}
